<div>
  <div class="modal-content">
    <div class="modal-body">
      <h3 class="modalHeader">Are you sure you want to delete this?</h3>
    </div>
    <div class="modal-footer">
      <button type="submit" id="approve-btn" class="btn btn-danger" (click)="confirm()">Delete</button>
      <button type="button" class="btn btn-default" data-dismiss="modal" (click)="closeModal()">Cancel</button>
    </div>
  </div>
</div>

<!-- <div class="modal-dialog">
  <div class="modal-content">
    <div class="modal-header">
      <button type="button" class="close" (click)="close()">&times;</button>
      <h4 class="modal-title">{{title || 'Confirm'}}</h4>
    </div>
    <div class="modal-body">
      <p>{{message || 'Are you sure?'}}</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="confirm()">OK</button>
      <button type="button" class="btn btn-default" (click)="close()">Cancel</button>
    </div>
  </div>
</div>` -->